export default "__VITE_PUBLIC_ASSET__1c36125d__"